import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { Box, Tab } from "@mui/material";
import React, { useState } from "react";
import TabContext from "@mui/lab/TabContext";
import { useFormik } from "formik";
import { ManageBookingSchema } from "../../validations/Schema";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";

const VisaManageBooking = () => {
  const typeList = [
    { label: "All", value: "All" },
    { label: "Live", value: "Live" },
    { label: "To be Cancelled", value: "To be Cancelled" },
    { label: "Cancelled", value: "Cancelled" },
  ];

  const paymentMode = [
    { label: "TopUp", value: "TopUp" },
    { label: "Payment Gateway", value: "Payment Gateway" },
    { label: "Credit", value: "Credit" },
  ];

  const initialValues = {
    spnr: "",
    hotelConfirmation: "",
    fromDate: "",
    toDate: "",
    searchBy: "",
    firstName: "",
    lastName: "",
    customerName: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ManageBookingSchema,
    onSubmit(values, formikHelpers) {
      console.log("Form submitted with values:", values);
    },
  });

  const [activeTab, setActiveTab] = useState("home");
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  function dayjs(fromDate: string): import("dayjs").Dayjs | null {
    throw new Error("Function not implemented.");
  }

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">Visa Manage Booking</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <div className="card card-custom ">
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label="Booked History"
                          value="1"
                          className={`tab ${
                            activeTab === "home" ? "active" : ""
                          }`}
                        />
                        <Tab
                          label="PNR Verification"
                          value="2"
                          className={`tab ${
                            activeTab === "about" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("about")}
                        />
                      </TabList>
                      <div className="tab-content">
                        <TabPanel value="1">
                          <div className="row mt-3">
                            <div className="col-md-4 mb-3">
                              <MuiInput placeholder="S PNR" label={"S PNR"} />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiDatePicker
                                label="Booked From Date"
                                value={null}
                                onChange={function (date: string): void {
                                  throw new Error("Function not implemented.");
                                }}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiDatePicker
                                label="Booked To Date"
                                value={null}
                                onChange={function (date: string): void {
                                  throw new Error("Function not implemented.");
                                }}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder={"Status"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Agency Name"
                                label={"Agency Name"}
                              />
                            </div>
                          </div>

                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn"
                              label="Clear"
                              onClick={() => formik.resetForm()}
                              type="submit"
                            />
                            <MuiButton
                              className="get-btn"
                              label="Get History"
                              onClick={() => {}}
                              type="submit"
                            />
                          </div>
                        </TabPanel>

                        <TabPanel value="2">
                          <div className="row mt-3">
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="S PNR"
                                label={"S PNR"}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Payment Ref No."
                                label={"Payment Ref No."}
                              />
                            </div>

                
                          </div>

                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn"
                              label="Clear"
                              onClick={() => formik.resetForm()}
                              type="submit"
                            />
                            <MuiButton
                              className="get-btn"
                              label="ok"
                              onClick={() => {}}
                              type="submit"
                            />
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default VisaManageBooking;
